export default __webpack_public_path__ + "static/media/aquawax-bold.330f4eaa.ttf";